<template>
  <div class="accordion">
    <div
      class="accordion__item"
      :class="itemsStatus[i] ? 'accordion__item--active' : null"
      v-for="(content, i) in items"
      :key="i"
    >
      <div class="accordion__header" v-on:click="toggleItem($event, i)">
        <span>{{ content.title }}</span>
        <span class="accordion__toggle_icon">
          <Icon type="arrow-right" />
        </span>

        <div class="accordion__activeline" />
      </div>
      <div class="accordion__body" :ref="'accordion-body-' + i">
        <div class="accordion__content">
          <div v-sanitize="content.description" />

          <template v-if="content.buttons">
            <ButtonLink
              v-for="(button, i) in content.buttons"
              :key="`button-${i}`"
              :label="button.label"
              :href="button.href"
              :color="
                backgroundColor !== undefined && backgroundColor === 'black'
                  ? 'yellow'
                  : 'black'
              "
              :noHover="button.noHover || null"
              :icon="button.icon || null"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  data: function () {
    return {
      itemsStatus: [],
    };
  },
  props: {
    items: { type: Array, required: true },
    backgroundColor: { type: String, required: false },
  },
  mounted: function () {
    this.itemsStatus = Array(this.items.length).fill(false);
  },
  methods: {
    toggleItem: function (e, i) {
      e.preventDefault();
      let el = this.$refs["accordion-body-" + i][0];
      if (this.itemsStatus[i] === false) {
        this.itemsStatus[i] = true;
        gsap.to(el, {
          duration: 0.25,
          height: el.scrollHeight,
          ease: "power04.inOut",
        });
      } else {
        this.itemsStatus[i] = false;
        gsap.to(el, { duration: 0.2, height: 0, ease: "power04.inOut" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  position: relative;

  &__header {
    position: relative;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    border-bottom: 1px dashed #ccc;
    padding: 1em 0 0.5em 0;
    transition: 0.2s;
    // @include typo--faq-header;
    &:hover {
      color: colors("yellow");
      &:after {
        transform: scaleX(1);
      }
    }
    &:after {
      content: "";
      height: 2px;
      width: 100%;
      background: colors("yellow");
      position: absolute;
      bottom: -2px;
      left: 0;
      transition: 0.2s ease-out;
      transform-origin: left;
      transform: scaleX(0);
    }
  }
  &__body {
    height: 0;
    overflow: hidden;
  }
  &__activeline {
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: colors("yellow");

    display: none;
  }
  &__item {
    position: relative;
    &--active {
      .accordion__header {
        // color: colors("yellow");
        // border-bottom: 2px solid colors("yellow");
        @include niveau-grotesk-medium;
      }
      .accordion__toggle_icon {
        :deep(svg) {
          transform: rotate(-90deg);
        }
      }
    }
    &:last-of-type {
      .accordion__header {
        border-width: 0;
      }
    }
    :deep(.button__label) {
      @include niveau-grotesk-regular;
    }
  }
  &__content {
    padding: 1rem 1rem 1rem 0rem;
    border-bottom: 1px dashed #ccc;
    // @media (min-width: $break-large) {
    //   padding: 2rem 1rem 3rem 0rem;
    // }
  }
  &__toggle_icon {
    width: 0.8em;
    :deep(svg) {
      transition: 0.5s;
    }
  }
}
</style>
